// Library Methods
import i18next from "i18next";

// Components
import Box from "@mui/material/Box";
import OperatingManualContent from "../OperatingManualContent/OperatingManualContent";

import launchImg from "src/assets/images/operating-manual/appendix-b/launch.png";
import launchFrImg from "src/assets/images/operating-manual/appendix-b/launch-fr.png";
import calibrateImg from "src/assets/images/operating-manual/appendix-b/calibrate.png";
import calibrateFrImg from "src/assets/images/operating-manual/appendix-b/calibrate-fr.png";
import countdownImg from "src/assets/images/operating-manual/appendix-b/countdown.png";
import countdownFrImg from "src/assets/images/operating-manual/appendix-b/countdown-fr.png";
import completeImg from "src/assets/images/operating-manual/appendix-b/complete.png";
import completeFrImg from "src/assets/images/operating-manual/appendix-b/complete-fr.png";

// Config
import { priorityLanguageMap } from "src/config/languages";

type AppendixBType = {
  title: string;
};

const AppendixB = ({ title }: AppendixBType) => {
  const currentLang = i18next.language as keyof typeof priorityLanguageMap;

  const imageBackgroundSx = { backgroundColor: "#FFF" };

  return (
    <OperatingManualContent title={title}>
      <Box sx={{ display: "flex", flexDirection: "column", gap: "20px" }}>
        <Box sx={imageBackgroundSx}>
          <img
            src={currentLang === "fr" ? launchFrImg : launchImg}
            width="100%"
            alt="launch"
          />
        </Box>
        <Box sx={imageBackgroundSx}>
          <img
            src={currentLang === "fr" ? calibrateFrImg : calibrateImg}
            width="100%"
            alt="calibrate"
          />
        </Box>
        <Box sx={imageBackgroundSx}>
          <img
            src={currentLang === "fr" ? countdownFrImg : countdownImg}
            width="100%"
            alt="countdown"
          />
        </Box>
        <Box sx={imageBackgroundSx}>
          <img
            src={currentLang === "fr" ? completeFrImg : completeImg}
            width="100%"
            alt="complete"
          />
        </Box>
      </Box>
    </OperatingManualContent>
  );
};

export default AppendixB;
